export default __webpack_public_path__ + "static/media/sort.600c66aa.svg";